import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  icon,
  title,
  color,
  width = 'w-full',
  className = '',
  textColor = 'text-white',
  disabled,
  click
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`relative ${width} items-baseline inline-flex justify-center border-transparent px-5 py-3 border text-xs md:text-sm leading-5 font-medium rounded-md ${className} ${
        disabled ? 'cursor-not-allowed text-gray-300' : textColor + ' ' + color
      }  focus:outline-none`}
      onClick={click}
    >
      {icon} {title}
    </button>
  );
};

Button.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  textColor: PropTypes.string,
  paddingClass: PropTypes.string,
  click: PropTypes.func
};

export default Button;
